import classNames from 'classnames'

import { ReactComponent as Minus } from 'images/minus.svg'
import { ReactComponent as Plus } from 'images/plus.svg'

import './input.style.css'
import { useEffect } from 'react'

export type Props = {
  min?: number
  max?: number
  value: number
  onChange?: (value: number) => void
}

export const NumberInput = ({ min = 0, max = Number.MAX_VALUE, value, onChange }: Props) => {
  useEffect(() => {
    if (value < min) {
      onChange?.(min)
    }

    if (value > max) {
      onChange?.(max)
    }
  }, [max, min, onChange, value])

  const handleOnChange = (e) => {
    onChange?.(e.target.value)
  }

  const handleOnMinusClick = () => {
    if (value - 1 < min) return

    onChange?.(value - 1)
  }
  const handleOnPlusClick = () => {
    if (value + 1 > max) return

    onChange?.(value + 1)
  }

  const minusClassName = classNames('number-input__controll', {
    disabled: value <= min,
  })

  const plusClassName = classNames('number-input__controll', {
    disabled: value >= max,
  })

  return (
    <div className="number-input">
      <span className={minusClassName} onClick={handleOnMinusClick}>
        <Minus />
      </span>
      <input
        id="number-input"
        type="number"
        value={value}
        min={min}
        max={max}
        onChange={handleOnChange}
      />
      <span className={plusClassName} onClick={handleOnPlusClick}>
        <Plus />
      </span>
    </div>
  )
}
